import { TableBody } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useTranslation } from "react-i18next";
import IconMessage, { IconMessageIcon } from "./IconMessage";
import { tbodyStyle } from "../constants";

export interface FailedToLoadProps {
    onClickRetry: () => void;
}

const FailedToLoad = (props: FailedToLoadProps) => {
    const { onClickRetry } = props;
    const { t } = useTranslation();
    return <TableBody
        style={tbodyStyle}>
        <TableRow style={tbodyStyle}>
            <TableCell colSpan={20} padding="none"
                style={{
                    height: 'calc(100vh - 512px)',
                    borderBottom: "none",
                    width: "100vw"
                }}>
                <IconMessage
                    title={t("components.iconMessage.failedToLoad.title")}
                    icon={IconMessageIcon.ERROR}
                    subtitle={t("components.iconMessage.failedToLoad.subtitle")}
                    buttonText={t("components.iconMessage.failedToLoad.buttonText")}
                    onClickButton={onClickRetry} />
            </TableCell>
        </TableRow>
    </TableBody>
};

export default FailedToLoad;
